<template>
  <layout-main-inner
    v-loading="loading"
    showBack
    :title="$route.meta.name">
    <layout-card-wrap>
      <el-descriptions title="基础信息">
        <el-descriptions-item label="企业名称">{{ info.vendorName }}</el-descriptions-item>
        <el-descriptions-item label="信用代码">{{ info.unifiedCreditCode }}</el-descriptions-item>
        <el-descriptions-item label="企业类型"> {{ info.scmOpenFlag === 1 ? '供应链' : '非供应链' }}</el-descriptions-item>
        <el-descriptions-item label="联系人员">{{ info.vendorPerson }}</el-descriptions-item>
        <el-descriptions-item label="联系号码">{{ info.vendorPhone }}</el-descriptions-item>
        <el-descriptions-item label="所属机构">{{ info.sgsName }}</el-descriptions-item>
        <el-descriptions-item
          :span="3"
          label="联系地址"> {{ info.provinceName }}-{{ info.cityName }}-{{ info.areaName }}-{{ info.vendorAddress }}</el-descriptions-item>
        <el-descriptions-item label="营业执照">
          <el-image
            v-if="info.businessLicenceFile"
            fit="contain"
            style="width: 80px; height: 80px"
            :src="info.businessLicenceFile"
            :preview-src-list="[info.businessLicenceFile]">
          </el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        v-if="info.memberFlag === 1"
        title="扩展信息">
        <el-descriptions-item label="企业简称">{{ info.vendorShortname }}</el-descriptions-item>
        <el-descriptions-item label="企业标签">{{ info.labels }}</el-descriptions-item>
        <el-descriptions-item label="经营范围"> {{ info.companyBusinessCategorys }}</el-descriptions-item>
        <el-descriptions-item
          :span="3"
          label="企业简介">{{ info.vendorDesc }}</el-descriptions-item>
        <el-descriptions-item label="企业LOGO">
          <el-image
            v-if="info.coverImage"
            fit="contain"
            style="width: 80px; height: 80px"
            :src="info.coverImage"
            :preview-src-list="[info.coverImage]">
          </el-image>
        </el-descriptions-item>
        <el-descriptions-item label="图文详情">
          <desc-images v-model="info.descImages"></desc-images>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        v-if="info.memberFlag === 1"
        title="当前有效证书">
        <el-descriptions-item
          :span="3"
          label="证书列表">
          <el-table
            border
            :data="list">
            <el-table-column
              label="证书名称"
              min-width="180"
              prop="certName"> </el-table-column>
            <el-table-column
              label="证书图片"
              min-width="360px">
              <template slot-scope="{row}">
                <image-list :list="row.certFile" />
              </template>
            </el-table-column>
            <el-table-column
              label="有效期"
              min-width="180">
              <template slot-scope="{row}">
                {{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}
              </template>
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import ImageList from '../../components/image-list.vue'
import DescImages from '../../components/public/desc-images.vue'
export default {
  name: 'VendorCertificate',
  components: { DescImages, ImageList },
  data() {
    return {
      loading: true,
      info: {},
      list: []
    }
  },
  mounted() {
    this.getlistInfo()
  },
  methods: {
    getlistInfo() {
      this.loading = true
      this.$store.dispatch('account/getvendor', {
        payload: { ...this.$route.query },
        success: (res) => {
          this.loading = false
          console.log(res)
          const { labels, companyBusinessCategorys, descImages, memberFlag } = res.data
          this.info = {
            ...res.data,
            labels: labels ? labels.join('，') : '',
            companyBusinessCategorys: companyBusinessCategorys ? companyBusinessCategorys.join('，') : '',
            descImages: this.$splitImage(descImages)
          }
          if (memberFlag === 1) {
            this.getlist()
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getlist() {
      this.loading = true
      this.$$examApi.getcertificates({ ...this.$route.query })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.list = records.map(i => ({ ...i, certFile: this.$splitImage(i.certFile) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
